import { render, staticRenderFns } from "./joinUs.vue?vue&type=template&id=ba9e5f7e&scoped=true&"
import script from "./joinUs.vue?vue&type=script&lang=js&"
export * from "./joinUs.vue?vue&type=script&lang=js&"
import style0 from "./joinUs.vue?vue&type=style&index=0&id=ba9e5f7e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9e5f7e",
  null
  
)

export default component.exports